import React from 'react';
import './common.css';

// Horizontal progress bar. `label` makes it an accessible progressbar; without one it
// is decorative (the numbers next to it carry the meaning).
const Meter = ({ value, max, size = 'sm', label }) => {
  const pct = max > 0 ? Math.min(100, Math.max(0, Math.round((value / max) * 100))) : 0;
  const a11y = label
    ? { role: 'progressbar', 'aria-valuemin': 0, 'aria-valuemax': 100, 'aria-valuenow': pct, 'aria-label': label }
    : { 'aria-hidden': true };
  return (
    <div className={`meter meter-${size}`} {...a11y}>
      <div className={`meter-fill ${pct >= 100 ? 'complete' : ''}`} style={{ width: `${pct}%` }} />
    </div>
  );
};

export default Meter;
